var map = {
	"./Black Bob.png": 9408,
	"./Black Long.png": 7774,
	"./Black Short.png": 6308,
	"./Blonde Bob.png": 6715,
	"./Blonde Long.png": 4451,
	"./Blonde Short.png": 4239,
	"./Brown Bob.png": 1289,
	"./Brown Long.png": 179,
	"./Brown Short.png": 3718,
	"./Red Bob.png": 980,
	"./Red Long.png": 2302,
	"./Red Short.png": 4757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5715;